<template>
	<aside class="menu">
    <ul class="menu-list" style="margin: 0; list-style: none;">
      <li :style="dataProvider.page.total > 1 ? 'border-bottom: 1px solid #e3e3e3;' : ''">
      	<a href="" @click.prevent="selectConversation(conversation)" :style="is_selected ? 'background: whitesmoke;' : ''">
      		<div class="columns is-mobile is-vcentered">
      			<div class="column is-narrow">
              <figure class="image is-42x42 is-circle">
                <avatar :avatar_url="conversation.roomImg" inputStyle="box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08); max-height: none;"></avatar>
              </figure>
            </div>
      			<div class="column truncated-text" style="padding-left: 0;">
      				<p class="title is-6" style="font-weight: 700;">{{ conversation.roomTitle }}</p>
      				<p class="subtitle is-6 has-text-grey" style="font-size: 15px; margin-bottom: 7px;"><small>{{ conversation.roomDesc }}</small></p>
      			</div>
            <div class="column is-narrow" v-if="conversation.newMessage">
              <i class="fas fa-circle has-text-danger" style="font-size: 9px;"></i>
            </div>
            <div class="column is-narrow" v-if="is_selected">
              <b-dropdown aria-role="list" position="is-bottom-left">
                <button class="button is-text is-small" slot="trigger">
                  <b-icon icon="dots-vertical"></b-icon>
                </button>

                <b-dropdown-item aria-role="listitem">
                  <a href="" class="has-text-danger" @click.prevent="removeConversation(conversation)">Hapus</a>
                </b-dropdown-item>
              </b-dropdown>
            </div>
      		</div>
      	</a>
      </li>
    </ul>
  </aside>
</template>

<script>
import { CONVERSATION } from '~/consts'

export default {
  props: {
    conversation: {
      type: Object,
      required: true
    },
    is_selected: {
      type: Boolean,
      default: false
    },
    dataProvider: {
      type: Object,
      required: false
    },
    selectConversation: {
      type: Function,
      default: () => {}
    },
    onDeleted: {
      type: Function,
      default: () => {}
    },
    onFailDelete: {
      type: Function,
      default: () => {}
    }
  },

  methods: {
    removeConversation(conversation) {
      this.$buefy.dialog.confirm({
        message: 'Apakah anda yakin akan menghapus percakapan ini?',
        confirmText: 'Hapus',
        cancelText: 'Batal',
        onConfirm: () => {
          this.$axios.post(CONVERSATION.DELETE(conversation.id))
            .then(({ data }) => {
              if (data.applicationSystem.code == 0) {
                this.onDeleted()
              } else {
                this.onFailDelete();
              }
            })
            .catch(() => {
              this.onFailDelete();
            })
        }
      })
    }
  }
}
</script>
